import { render, staticRenderFns } from "./voucherPage.vue?vue&type=template&id=72487be2&scoped=true"
import script from "./voucherPage.vue?vue&type=script&lang=js"
export * from "./voucherPage.vue?vue&type=script&lang=js"
import style0 from "./voucherPage.vue?vue&type=style&index=0&id=72487be2&prod&lang=scss&scoped=true"
import style1 from "./voucherPage.vue?vue&type=style&index=1&id=72487be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72487be2",
  null
  
)

export default component.exports